import * as React from 'react';
import { Component } from 'react';
import { History } from 'history';
import { AppUser } from 'Src/views/App/App';
import { Loader } from 'Src/components/Loader/Loader';

interface Props {
  user: AppUser;
  history: History;
}

class ClubsLanding extends Component<Props & { audience: 'parent' | 'student' }> {
  componentDidMount() {
    this.props.history.replace('/clubBookings/inbox');
  }

  render() {
    return <Loader />;
  }
}

export const ParentClubsLanding = props => <ClubsLanding {...props} audience="parent" />;
export const StudentClubsLanding = props => <ClubsLanding {...props} audience="student" />;
